/**
 * Klaviyo star rating tweaks.
 *
 * The widget markup is injected by the Klaviyo app, so we can't change it at
 * render time. This rewrites the review count from "181 reviews" to "(181)"
 * once the app has drawn it, and re-applies on any redraw.
 *
 * Star sizing lives in custom.css.
 */
(function () {
  var COUNT_PATTERN = /(^|\s)(\d[\d,]*)\s+reviews?\b/i;

  function rewriteCount(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!text || text.indexOf('(') !== -1) continue;

      var match = text.match(COUNT_PATTERN);
      if (!match) continue;

      node.nodeValue = text.replace(COUNT_PATTERN, '$1(' + match[2] + ')');
    }
  }

  function rewriteAll() {
    document.querySelectorAll('.klaviyo-star-rating-widget').forEach(rewriteCount);
  }

  function init() {
    rewriteAll();

    // The app renders asynchronously and redraws on section reloads in the
    // theme editor, so keep watching rather than running once.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          rewriteAll();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
